import { Path, PathValue, UseFormReturn } from "react-hook-form"

interface UseInternalFieldArrayProps<TFieldValues extends Record<string, any>> {
  name: Path<TFieldValues>;
}

export const useInternalFieldArray = <
  TFieldValues extends Record<string, any>,
  TName extends Path<TFieldValues>
>({ watch, setValue, name }: UseInternalFieldArrayProps<TFieldValues> & UseFormReturn<TFieldValues>) => {
  type FieldArrayType = Extract<PathValue<TFieldValues, TName>, unknown[]>;

  const fields = (watch(name) as FieldArrayType) ?? [] as FieldArrayType;

  const append = (value: FieldArrayType[number]) => {
    setValue(name, [...fields, value] as FieldArrayType);
  };

  const remove = (index: number) => {
    const newFields = [...fields];

    newFields.splice(index, 1);

    setValue(name, newFields as FieldArrayType);
  };

  const update = (index: number, value: FieldArrayType[number]) => {
    const newFields = [...fields];

    newFields.splice(index, 1, value as FieldArrayType);

    setValue(name, newFields as FieldArrayType);
  };

  return { fields, append, remove, update };
}
